export const enum FeatureTabs {
    OVERVIEW_TAB = 0,
    CODE_TAB = 1,
    VALIDATE_TAB = 2,
    HISTORY_TAB = 3,
    WHERE_USED_TAB = 4
}